module.exports = {"id":"198810","name":"Bailey Wright","rating":"72","photo":"./data/images/photos/3/198810.png","club":{"name":"Bristol City","logo":"./data/images/clubs/BristolCity.png"},"positions":["DC","DD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BaileyWright0.json
// module id = 522
// module chunks = 0